import type { DiscoveredRouteModule } from '@/router/generator/types';

const UnauthorizedView = () => import('@/views/error-pages/UnauthorizedView.vue');
export const NAME_UNAUTHORIZED = 'Unauthorized';
export const PATH_UNAUTHORIZED = '/unauthorized';

export const route: DiscoveredRouteModule = {
  id: 'root.error.unauthorized',
  scope: 'root',
  name: NAME_UNAUTHORIZED,
  path: PATH_UNAUTHORIZED,
  component: UnauthorizedView,
  meta: { isErrorPage: true, dataLoaders: ['unauthorized_page'] },
};


